'use client';
import { LocaleUtil } from '@/utils/Locale.util';
import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import 'dayjs/locale/fr';
import 'dayjs/locale/nl';
import { useLocale } from 'next-intl';
import { ReactNode } from 'react';
import { surfaceVariablesResolver } from './surface.variables';
import { theme } from './weinvest.theme';

/**
 * Owns `MantineProvider` on the client side of the boundary.
 *
 * `cssVariablesResolver` is a function, and a function cannot be handed from a server component to a
 * client one — the root layout passing it directly threw at request time while type-checking and
 * building clean. Nothing moves into the bundle that was not already there: `MantineProvider` is a
 * client component regardless.
 *
 * `DatesProvider` names the calendars in the viewer's language; Mantine reads the month and day
 * names from dayjs, so its `fr` and `nl` locales have to be loaded here.
 */
export const ThemeProvider = ({ children }: { children: ReactNode }) => {
	const locale = useLocale();

	return (
		<MantineProvider theme={theme} cssVariablesResolver={surfaceVariablesResolver}>
			<DatesProvider settings={{ locale: LocaleUtil.getIso2LocaleBasedOnIso4(locale) }}>{children}</DatesProvider>
		</MantineProvider>
	);
};
